function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _Symbol$for;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var _require = require('nanoid/non-secure'),
    nanoid = _require.nanoid; // Redux action name.


var STATE_UPDATE = 'uppy/STATE_UPDATE'; // Pluck Uppy state from the Redux store in the default location.

var defaultSelector = function defaultSelector(id) {
  return function (state) {
    return state.uppy[id];
  };
};
/**
 * Redux store.
 *
 * @param {object} opts.store - The Redux store to use.
 * @param {string} opts.id - This store instance's ID. Defaults to a random string.
 *    If you need to access Uppy state through Redux, eg. to render custom UI, set this to something constant.
 * @param {Function} opts.selector - Function, `(state) => uppyState`, to pluck state from the Redux store.
 *    Defaults to retrieving `state.uppy[opts.id]`. Override if you placed Uppy state elsewhere in the Redux store.
 */


var _id = /*#__PURE__*/_classPrivateFieldLooseKey("id");

var _selector = /*#__PURE__*/_classPrivateFieldLooseKey("selector");

var _store = /*#__PURE__*/_classPrivateFieldLooseKey("store");

_Symbol$for = Symbol.for('uppy test: get id');

var ReduxStore = /*#__PURE__*/function (_Symbol$for2) {
  function ReduxStore(opts) {
    _classCallCheck(this, ReduxStore);

    Object.defineProperty(this, _id, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _selector, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _store, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _store)[_store] = opts.store;
    _classPrivateFieldLooseBase(this, _id)[_id] = opts.id || nanoid();
    _classPrivateFieldLooseBase(this, _selector)[_selector] = opts.selector || defaultSelector(_classPrivateFieldLooseBase(this, _id)[_id]); // Calling `setState` to dispatch an action to the Redux store.
    // The intent is to make sure that the reducer has run once.

    this.setState({});
  }

  _createClass(ReduxStore, [{
    key: "setState",
    value: function setState(patch) {
      _classPrivateFieldLooseBase(this, _store)[_store].dispatch({
        type: STATE_UPDATE,
        id: _classPrivateFieldLooseBase(this, _id)[_id],
        payload: patch
      });
    }
  }, {
    key: "getState",
    value: function getState() {
      return _classPrivateFieldLooseBase(this, _selector)[_selector](_classPrivateFieldLooseBase(this, _store)[_store].getState());
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;

      var prevState = this.getState();
      return _classPrivateFieldLooseBase(this, _store)[_store].subscribe(function () {
        var nextState = _this.getState();

        if (prevState !== nextState) {
          var patch = getPatch(prevState, nextState);
          cb(prevState, nextState, patch);
          prevState = nextState;
        }
      });
    }
  }, {
    key: _Symbol$for2,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _id)[_id];
    }
  }]);

  return ReduxStore;
}(_Symbol$for);

ReduxStore.VERSION = "2.0.3";

function getPatch(prev, next) {
  var nextKeys = Object.keys(next);
  var patch = {};
  nextKeys.forEach(function (k) {
    if (prev[k] !== next[k]) patch[k] = next[k];
  });
  return patch;
}

function reducer(state, action) {
  if (state === void 0) {
    state = {};
  }

  if (action.type === STATE_UPDATE) {
    var newState = _objectSpread(_objectSpread({}, state[action.id]), action.payload);

    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.id, newState));
  }

  return state;
}

function middleware() {
  // Do nothing, at the moment.
  return function () {
    return function (next) {
      return function (action) {
        next(action);
      };
    };
  };
}

module.exports = ReduxStore;
module.exports.ReduxStore = ReduxStore;
module.exports.STATE_UPDATE = STATE_UPDATE;
module.exports.reducer = reducer;
module.exports.middleware = middleware;